import { createSlice } from "@reduxjs/toolkit";
import {
  fetchRoomsAction,
  createRoomAction,
  joinMeetingAction,
  checkJoinStatusAction,
  completeRoomAction,
  adminJoinMeetingAction,
  getWaitingParticipantsAction,
  approveParticipantAction,
  rejectParticipantAction,
  removeParticipantAction,
  leaveMeetingAction,
} from "../../actions/room/roomActions";

const roomSlice = createSlice({
  name: "room",
  initialState: {
    rooms: [],
    loading: false,
    error: null,
    currentRoom: null,
    waitingParticipants: [],
    joinStatus: null,
  },
  reducers: {
    setRooms(state, action) {
      state.rooms = action.payload;
    },
    setCurrentRoom(state, action) {
      state.currentRoom = action.payload;
    },
    clearRoomError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(fetchRoomsAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoomsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.rooms = action.payload?.rooms || [];
        return state;
      })
      .addCase(fetchRoomsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createRoomAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(createRoomAction.fulfilled, (state, action) => {
        state.loading = false;
        state.currentRoom = action.payload;
        return state;
      })
      .addCase(createRoomAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(joinMeetingAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(joinMeetingAction.fulfilled, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(joinMeetingAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(checkJoinStatusAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(checkJoinStatusAction.fulfilled, (state, action) => {
        state.loading = false;
        state.joinStatus = action.payload;
        return state;
      })
      .addCase(checkJoinStatusAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(completeRoomAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(completeRoomAction.fulfilled, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(completeRoomAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(adminJoinMeetingAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(adminJoinMeetingAction.fulfilled, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(adminJoinMeetingAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getWaitingParticipantsAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getWaitingParticipantsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.waitingParticipants = action.payload?.participants || [];
        return state;
      })
      .addCase(getWaitingParticipantsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(approveParticipantAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(approveParticipantAction.fulfilled, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(approveParticipantAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(rejectParticipantAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(rejectParticipantAction.fulfilled, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(rejectParticipantAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(removeParticipantAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(removeParticipantAction.fulfilled, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(removeParticipantAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(leaveMeetingAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(leaveMeetingAction.fulfilled, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(leaveMeetingAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }),
});

export const { setRooms, setCurrentRoom, clearRoomError } = roomSlice.actions;
export default roomSlice.reducer;
